import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Import Link here
import HeaderBottom from "../../components/HomePage/HeaderBottom";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [author, setAuthor] = useState([]);
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 12;

  useEffect(() => {
    fetch("https://seoaudit02-2nd-a6f62d82ab8a.herokuapp.com/categorys")
      .then((res) => res.json())
      .then((info) => setCategories(info))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  // Fetch author details
  useEffect(() => {
    fetch("https://seoaudit02-2nd-a6f62d82ab8a.herokuapp.com/author")
      .then((res) => res.json())
      .then((info) => setAuthor(info))
      .catch((error) => console.error("Error fetching author details:", error));
  }, []);

  // Fetch all posts from the backend
  useEffect(() => {
    fetch("https://seoaudit02-2nd-a6f62d82ab8a.herokuapp.com/posts")
      .then((res) => res.json())
      .then((data) => setPosts(data))
      .catch((error) => console.error("Error fetching posts:", error));
  }, []);

  // Get current posts based on the page number
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(posts.length / postsPerPage);

  return (
    <>
      <HeaderBottom />
      <main className="main-wrapper min-vh-100">
        <div className="container my-5">
          <h2 className="text-center mb-4">All Blog Posts</h2>
          <div className="container mt-5">
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
              {currentPosts.reverse().map((post) => (
                <div className="col" key={post._id}>
                  <div className="card shadow border-light rounded-3 h-100">
                    <div className="card">
                      <Link to={`/blog/${post.titleSlug}`}>
                        <img
                          src={post.featuredImage}
                          className="card-img-top img-fluid rounded-top"
                          alt="Post Thumbnail"
                          style={{ height: "200px", objectFit: "cover" }}
                        />
                      </Link>
                      <div className="card-body">
                        <p className="card-title">Posted on {post.postDate}</p>
                        <p className="card-subtitle text-muted mb-2"></p>
                      </div>
                    </div>
                    <div className="card-body">
                      {author.map((a) => (
                        <p className="card-subtitle text-muted mb-2" key={a._id}>
                          <span className="me-2">
                            <i className="fas fa-user-circle"></i> {/* Author icon */}
                          </span>
                          by <span className="fw-bold text-dark">{a.allAuthorName}</span>
                        </p>
                      ))}
                      <h4 className="card-title mb-3">
                        <Link to={`/blog/${post.titleSlug}`} className="text-decoration-none text-dark">
                          {post.postTitle}
                        </Link>
                      </h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination Section */}
            {posts.length > postsPerPage && (
              <div className="d-flex justify-content-center mt-4">
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    {/* Previous Button */}
                    <li className="page-item">
                      <button
                        className="page-link"
                        aria-label="Previous"
                        onClick={() => currentPage > 1 && paginate(currentPage - 1)}
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </button>
                    </li>
                    {/* Page Numbers */}
                    {Array.from({ length: totalPages }, (_, index) => index + 1).map((number) => (
                      <li
                        key={number}
                        className={`page-item ${currentPage === number ? "active" : ""}`}
                      >
                        <button className="page-link" onClick={() => paginate(number)}>
                          {number}
                        </button>
                      </li>
                    ))}
                    {/* Next Button */}
                    <li className="page-item">
                      <button
                        className="page-link"
                        aria-label="Next"
                        onClick={() => currentPage < totalPages && paginate(currentPage + 1)}
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default Blog;
